import { CrossWindowDataRefetchType, NameSpaces, sendCrossTabEvent } from 'modules/EventsManager';

type BroadcastRefreshCase = () => Promise<unknown>;

type RefetchType = CrossWindowDataRefetchType | CrossWindowDataRefetchType[];

/**
 * Fires the current-case refresh + cross-tab data-refetch pair together, in a fixed order
 * (broadcast first, then the cross-tab event(s)), so the two primitives that must travel
 * together to keep cross-tab state consistent can't drift apart at each call site.
 *
 * Pass the `useBroadcastRefreshCurrentCase()` result (or an equivalent refresh callback that
 * is threaded through props, e.g. LinkCases) as `broadcastRefreshCase`. Pass an array of
 * types to emit several refetch events off a single broadcast.
 *
 * See RP-5890.
 */
export async function broadcastCaseAndWorklistRefresh(
  broadcastRefreshCase: BroadcastRefreshCase,
  type: RefetchType
): Promise<void> {
  await broadcastRefreshCase();

  const types = Array.isArray(type) ? type : [type];
  types.forEach((refetchType) =>
    sendCrossTabEvent(NameSpaces.CROSS_WINDOW_DATA_REFETCH, { type: refetchType })
  );
}
